<template>
    <kubernetes-common-panel
            v-model="value"
            :img="img"
            :readOnly="readOnly"
            @openDesDoc="desDocOpen"
            @close="closePanel"
    >
        <template slot="headline">
            <v-list-item-title class="headline">
                {{ value._type }}
            </v-list-item-title>
        </template>

        <template slot="descriptionText">
            <span>{{ descriptionText }}</span>
        </template>

        <template slot="edit-property">
            <v-text-field                                
                    label="Name"
                    v-model="value.object.metadata.name"
                    autofocus
                    :disabled="readOnly"
            ></v-text-field>
            <v-text-field
                    label="Image"
                    :disabled="readOnly"
                    v-model="value.object.spec.jobTemplate.spec.template.spec.containers[0].image"
            ></v-text-field>
            <v-select
                    label="restartPolicy"
                    :disabled="readOnly"
                    v-model="value.object.spec.jobTemplate.spec.template.spec.restartPolicy"
                    :items="restartPolicyList"
            ></v-select>
            <v-label>Schedule</v-label>
            <v-cron-field
                    v-model="value.object.spec.schedule"
                    :readOnly="readOnly"
            ></v-cron-field>
        </template>
    </kubernetes-common-panel>

</template>


<script>
    import CronField from './CronField.vue';
    import KubernetesPanel from "../KubernetesPanel";

    export default {
        name: 'cronjob-property-panel',
        mixins: [KubernetesPanel],
        components: {
            CronField,
        },
        computed: {
            descriptionText() {
                return 'CronJob'
            },
            status() {
                return JSON.parse(JSON.stringify(this.value.status))
            },

        },
        data: function () {
            return {
                restartPolicyList: ['Always', 'OnFailure', 'Never'],
                activeTab: 0,
                tabItems: ["status", "property"],
            }
        },
        watch: {
            status: {
                deep: true,
                handler: function () {
                }
            },
        },
        methods: {
            desDocOpen() {
                window.open('https://kubernetes.io/docs/concepts/workloads/controllers/cron-jobs/')
            },
        }
    }
</script>

